import React from "react"

interface FormFieldProps {
  id: string
  label: string
  type: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  rows?: number
  autoComplete?: string
}

const FormField: React.FC<FormFieldProps> = ({ id, label, type, value, onChange, rows, autoComplete }) => {
  return (
    <div className="sm:col-span-2">
      {" "}
      {/* Make sure we use col-span-2 on larger screens for proper layout */}
      <label htmlFor={id} className="block font-bold text-black">
        {label}
      </label>
      <div>
        {type === "textarea" ? (
          <textarea
            id={id}
            name={id} // Ensure name is properly set
            value={value} // Use the value from the parent
            onChange={onChange} // Pass the onChange handler
            rows={rows}
            autoComplete={autoComplete} // AutoComplete support
            className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          />
        ) : (
          <input
            id={id}
            name={id} // Ensure the name is properly set
            value={value} // Use the value from the parent
            onChange={onChange} // Pass the onChange handler
            type={type}
            autoComplete={autoComplete} // AutoComplete support
            className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
          />
        )}
      </div>
    </div>
  )
}

export default FormField
